/** @deprecated Legacy helper — use Next.js routing (useParams, usePathname) or standard URL parsing in new code. */
export class UrlHelper {
  public static extractUUID(url: string): string | undefined {
    const uuidRegex = /([0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12})/i;
    const match = uuidRegex.exec(url);
    return match ? match[1] : undefined;
  }

  public static extractUUIDWithPrefix(url: string, prefix: string): string | undefined {
    const uuid = UrlHelper.extractUUID(url);
    if (!uuid) return undefined;
    return url.includes(`${prefix}${uuid}`) ? uuid : undefined;
  }

  public static getQueryParam<T = string>(paramName: string): T | undefined {
    if (typeof window === "undefined") return undefined;
    const params = new URLSearchParams(window.location.search);
    const value = params.get(paramName);
    return value !== null ? (value as T) : undefined;
  }

  public static getQueryParamNumber(paramName: string): number | undefined {
    const val = UrlHelper.getQueryParam<string>(paramName);
    if (!val) return undefined;
    const parsed = parseInt(val, 10);
    return !Number.isNaN(parsed) ? parsed : undefined;
  }
}
